const translations = {
  "en": {
    "and": "and",
    "By continuing, you agree to accept the": "By continuing, you agree to accept the",
    "Privacy Policy": "Privacy Policy",
    "Terms of Use": "Terms of Use"
  },
  "zh-tw": {
    "and": "和",
    "By continuing, you agree to accept the": "繼續操作，即表示你同意接受",
    "Privacy Policy": "隱私權政策",
    "Terms of Use": "使用條款"
  }
};

export default translations;
